namespace TabAurous.Retail {
    export interface POSQuotationForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        MF: Serenity.DecimalEditor;
        ImageName: Serenity.ImageUploadEditor;
        ItemDetails: POSQuotationItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class POSQuotationForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.Quotation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSQuotationForm.init)  {
                POSQuotationForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = POSQuotationItemsEditor;

                Q.initFormType(POSQuotationForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PartyId', w2,
                    'POSCustomerId', w3,
                    'CustomerName', w1,
                    'Address', w4,
                    'Mobile', w2,
                    'PanNumber', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'EmployeeId', w2,
                    'UserId', w5,
                    'MF', w6,
                    'ImageName', w7,
                    'ItemDetails', w8,
                    'FinancialYearId', w2,
                    'Pieces', w2,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'TaxAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'Remark', w4,
                    'ShipAddressId', w2,
                    'CompanyId', w2,
                    'ShipmentId', w2
                ]);
            }
        }
    }
}
